import React from 'react'

const Link = () => {
  return (
    <svg
      fill='none'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.585 12.517l.092.092a2.07 2.07 0 002.928 0l4.104-4.107a3.117 3.117 0 000-4.392l-1.82-1.82a3.113 3.113 0 00-4.391 0l-4.105 4.104a2.07 2.07 0 000 2.928l.092.092'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M9.415 11.481l-.092-.092a2.07 2.07 0 00-2.928 0L2.29 15.497a3.115 3.115 0 000 4.392l1.82 1.819a3.112 3.112 0 004.392 0l4.103-4.104a2.068 2.068 0 000-2.928l-.092-.092'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M7.974 16.026l8.05-8.053'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Link
